/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    SaveCustomerOrdersBulk,
    GetAllOrderTypes,
};

async function SaveCustomerOrdersBulk(bulkModel) {
    const response = await CommonPost('/api/CustomerOrderBulk/SaveCustomerOrdersBulk', null, bulkModel);
    return response;
}

async function GetAllOrderTypes() {
    const response = await CommonGet('/api/SpecialOrder/GetAllOrderTypes', null);
    return response.data;
}